import Pusher from 'pusher-js'
import { metaTagContent } from '@/helpers/documentHelpers.js'

function createPusherGlobalInstance() {
  return (window.pusher ??= new Pusher(PUSHER_KEY, {
    cluster: PUSHER_CLUSTER,
    channelAuthorization: {
      endpoint: '/api/pusher/chat-auth',
      headers: {
        'X-CSRF-Token': metaTagContent('csrf-token'),
      },
    },
  }))
}

export { createPusherGlobalInstance }
